import { render, staticRenderFns } from "./PrioridadeTabList.vue?vue&type=template&id=a92c5a0c&scoped=true"
import script from "./PrioridadeTabList.vue?vue&type=script&lang=js"
export * from "./PrioridadeTabList.vue?vue&type=script&lang=js"
import style0 from "./PrioridadeTabList.vue?vue&type=style&index=0&id=a92c5a0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a92c5a0c",
  null
  
)

export default component.exports